import { Component, EventEmitter, Input, Output, forwardRef } from "@angular/core";
import { NgIf, NgClass } from "@angular/common";
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormsModule } from "@angular/forms";
import { skeletonFadeIn, inputFadeIn } from "../../shared-animations";
import { generateSecureRandomString } from "../../../../shared/utils/random-utils";

@Component({
  selector: "NiFormTextarea, NiMultiline",
  templateUrl: "./ni-textarea.component.html",
  standalone: true,
  imports: [NgIf, NgClass, FormsModule],
  styleUrls: ["./ni-textarea.component.css"],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => NiTextareaComponent), multi: true }],
  animations: [skeletonFadeIn, inputFadeIn],
})

export class NiTextareaComponent implements ControlValueAccessor {
  @Input() id: string = `textarea-${generateSecureRandomString(7)}`;
  @Input() label: string = "";
  @Input() value: string = "";
  @Input() required: boolean = false;
  @Input() placeholder: string = "";
  @Input() rows: string | number = 4;
  @Input() cols: string | number = 100;
  @Input() maxLength: number = 1000;
  @Input() disabled: boolean = false;
  @Input() readonly: boolean = false;
  @Input() hasError: boolean = false;
  @Input() errorMessage: string = "";
  @Input() isLoading: boolean = false;
  @Output() onInput: EventEmitter<string> = new EventEmitter<string>();
      
  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: string): void {
    this.value = value || '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  handleInput(value: string): void {
    this.value = value;
    this.onChange(value);
    this.onInput.emit(value);
  }

  handleBlur(): void {
    this.onTouched();
  }
}
